import type { Controls, TimelineZoom } from './VodPlayer'
import { parsePlayerAt } from './playerUrl'
import type { AudioVisualizationMode } from './AudioVisualization'

export function parsePlayerParams(params: URLSearchParams) {
  const at = parsePlayerAt(params.get('at') ?? '')
  const value = params.get('controls')
  const controls: Controls =
    value === 'false' || value === 'none'
      ? 'none'
      : value === 'minimal'
        ? 'minimal'
        : 'full'
  const zoom = params.get('zoom')
  const visualization: AudioVisualizationMode =
    params.get('visualization') === 'spectrum' ? 'spectrum' : 'waveform'
  const defaultZoom: TimelineZoom =
    zoom === '6h' || zoom === '1h' || zoom === '10m' || zoom === 'day' ? zoom : 'day'
  return {
    camera: params.get('camera') ?? undefined,
    day: Number.isFinite(at) ? undefined : (params.get('day') ?? undefined),
    at: Number.isFinite(at) ? new Date(at).toISOString() : undefined,
    rangeStart: params.get('rangeStart') ?? undefined,
    rangeEnd: params.get('rangeEnd') ?? undefined,
    archiveOnly: params.get('archiveOnly') === 'true',
    controls,
    defaultZoom,
    visualization,
  }
}
